import angular from "angular";

export class ScriptService {

    static $inject = ['$q'];

    constructor(private $q) {
    }

    loadScript = (url) => {

        let deferred = this.$q.defer();

        // Check if script is already loaded
        if (document.querySelector('script[src="' + url + '"]')) {
            deferred.resolve();
        } else {
            // Create script element
            let script = document.createElement('script');
            script.src = url;
            // Add event listeners for script load and error
            script.onload = () => {
                deferred.resolve();
            };
            script.onerror = (error) => {
                deferred.reject(error);
            };

            // Append script element to head
            let head = document.getElementsByTagName('head')[0];
            head.appendChild(script);
        }

        return deferred.promise;
    };

    loadCss = (url) => {
        let deferred = this.$q.defer();

        // Check if CSS file is already loaded
        if (document.querySelector('link[href="' + url + '"]')) {
            deferred.resolve();
        } else {
            // Create link element
            let link = document.createElement('link');
            link.href = url;
            link.rel = 'stylesheet';

            // Add event listener for CSS load and error
            link.onload = () => {
                deferred.resolve();
            };
            link.onerror = (error) => {
                deferred.reject(error);
            };

            // Append link element to head
            let head = document.getElementsByTagName('head')[0];
            head.appendChild(link);
        }

        return deferred.promise;
    }

}
angular.module('eCareVault.common.services').service('ScriptService', ScriptService);

